// extracted by mini-css-extract-plugin
export default {"page":"t1-z","cartModal":"u1-z","checkout":"v1-z","placeholder":"w1-z","account":"x1-z"};